import React from 'react';

const Icon = ({ size = '60', fill = 'black', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 60 60" fill="none" {...other}>
            <path
                d="m42.794 19.053-3.84-4.08a1.369 1.369 0 0 1 1.994-1.876l6.01 6.386c.821.873.202 2.306-.997 2.306h-6.869c-3.492 0-6.358 3.046-6.358 6.843v8.21a1.368 1.368 0 0 1-2.737 0v-8.21c0-5.273 4.053-9.58 9.095-9.58h3.702Z"
                fill={fill}
            />

            <path
                d="M30.633 15.333H18.666a3.333 3.333 0 0 0-3.333 3.334V42a3.333 3.333 0 0 0 3.333 3.333H42A3.333 3.333 0 0 0 45.333 42V30.033"
                stroke="#03060B"
                strokeWidth="2.667"
                strokeLinecap="round"
            />
        </svg>
    );
};
export default React.memo(Icon);
